module.exports = __webpack_public_path__ + "img/wine-bottle.2083c289.svg";